/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Video_File_HelpInputs */



/**
* | output |
* | --- |
* | "Select a MP4, MOV, GXF, MPEG, or MXF video file" |
*
* @param {Embed_Captions_Video_File_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_video_file_help = /** @type {((inputs?: Embed_Captions_Video_File_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Video_File_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionnez un fichier video MP4, MOV, GXF, MPEG ou MXF")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie eine MP4-, MOV-, GXF-, MPEG- oder MXF-Videodatei aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona un file video MP4, MOV, GXF, MPEG o MXF")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите видеофайл в формате MP4, MOV, GXF, MPEG или MXF.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione un archivo de vídeo MP4, MOV, GXF, MPEG o MXF")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择 MP4、MOV、GXF、MPEG 或 MXF 视频文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("MP4、MOV、GXF、MPEG、またはMXFビデオファイルを選択します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक MP4, MOV, GXF, MPEG या MXF वीडियो फ़ाइल चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione um arquivo de vídeo MP4, MOV, GXF, MPEG ou MXF.")
	return /** @type {LocalizedString} */ ("Select a MP4, MOV, GXF, MPEG, or MXF video file")
});